import { createAction } from "@reduxjs/toolkit";
export const updateMaritalStatus = createAction('updateMaritalStatus');
export const updateIgnoreTax = createAction('updateIgnoreTax');
export const updateDarkMode = createAction('updateDarkMode');